module.exports = __webpack_public_path__ + "img/chechuangjiaju3.asm.6aa5e43b.jpg";